<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useLocale } from '@/composables/useLocale'
import type { Locale } from '@/config/tenants'

const { t } = useI18n()
const { current, available, set } = useLocale()

function onChange(event: Event): void {
  set((event.target as HTMLSelectElement).value as Locale)
}
</script>

<template>
  <label class="locale">
    <span class="visually-hidden">{{ t('locale.label') }}</span>
    <select class="locale__select" :value="current" @change="onChange">
      <option v-for="loc in available" :key="loc" :value="loc">{{ t(`locale.${loc}`) }}</option>
    </select>
  </label>
</template>

<style scoped>
/* Quiet by design (footer placement): borderless, no focus box - just a color
   cue on interaction. */
.locale__select {
  min-height: var(--size-touch);
  padding: var(--space-1) var(--space-2);
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--color-text-muted);
  font-size: var(--font-size-xs);
  letter-spacing: var(--tracking-label);
  cursor: pointer;
}

.locale__select:hover,
.locale__select:focus,
.locale__select:focus-visible {
  outline: none;
  color: var(--color-brand);
}
</style>
